import { useNavigate } from 'react-router-dom'

import { usePageTitle } from '../../hooks/usePageTitle'
import { ComputeFactory } from '../../models/ComputeFactory'
import { RecordFactory } from '../../models/RecordFactory'
import { RecordNotFoundError } from '../../models/errors/RecordNotFoundError'
import { ComponentData } from '../../utils/typing'
import { PocketComponent, PocketComponentProps, usePSComponent } from '../PocketComponent'
import { BaseRecordView } from '../common/sections'
import { DepositView } from './DepositView'

const viewWillAppear = async ({ urlParams }: PocketComponent) => {
    if (!urlParams.id) {
        throw new RecordNotFoundError('Deposit not found')
    }

    await RecordFactory.getInstance().fetchDeposit(urlParams.id)
    const deposit = await RecordFactory.getInstance().loadDeposit(urlParams.id)
    if (!deposit) {
        throw new RecordNotFoundError('Deposit not found')
    }

    const [payee, source, payments] = await Promise.all([
        deposit.owner?.id !== undefined
            ? RecordFactory.getInstance().loadPayee(deposit.owner.id)
            : undefined,
        deposit.source?.id !== undefined
            ? RecordFactory.getInstance().loadSource(deposit.source.id)
            : undefined,
        ComputeFactory.getInstance().fetchDepositPayments(deposit),
    ])
    if (!payee || !source) {
        throw new RecordNotFoundError('Deposit not found')
    }

    return { deposit, payee, source, payments }
}

const render = ({ data }: PocketComponentProps<ComponentData<typeof viewWillAppear>>) => {
    if (data instanceof RecordNotFoundError) {
        throw data
    }

    const { deposit, payee, source, payments } = data

    const navigate = useNavigate()

    usePageTitle('Deposit')

    return (
        <BaseRecordView
            title="Deposit"
            tag={deposit.statusTag ?? undefined}
            backButton={{ title: 'Deposits', onClick: () => navigate('/dashboards/deposits') }}
        >
            <DepositView deposit={deposit} payee={payee} source={source} payments={payments} />
        </BaseRecordView>
    )
}

export const DepositPage = usePSComponent(render, viewWillAppear)
